import React from 'react'

type TPillProps = {
  text: string
}

export default function Pill({ text }: Readonly<TPillProps>) {
  return (
    <div className='flex items-center justify-center rounded-full border border-pop-blue-100 bg-pop-blue-50 px-2 py-1'>
      <span className='text-xs font-semibold text-pop-blue-700'>{text}</span>
    </div>
  )
}
